import React from 'react'
import { PrivateRoutes } from '@/common/layouts/PrivateRoutes.tsx'
import { useAuth } from '@/common/hooks/useAuth.ts'

export const HcAdminRoutes: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isHc } = useAuth()

  if (!isHc) {
    throw new Error('Access Denied. Only HC allowed.')
  }

  return (
    <PrivateRoutes>
      {children}
    </PrivateRoutes>
  )
}